(async () => {
  const WORKER_URL = "https://license-worker.engineerwaqasabbasi.workers.dev";

  // Normalize the domain to match your Worker format
  const normalizeDomain = (domain) =>
    domain.replace(/^https?:\/\//, "").replace(/\/$/, "");

  const shopDomain = normalizeDomain(Shopify.shop);

  // --- Check license from Worker
  async function checkLicenseFromServer(key) {
    try {
      const res = await fetch(`${WORKER_URL}/validate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ shop: shopDomain, license_key: key }),
      });
      const data = await res.json();
      console.log("License validation:", data);
      return data.success && data.active;
    } catch (err) {
      console.error("License check failed:", err);
      return false;
    }
  }

  // --- Try to find active license (either local or from Worker)
  async function isShopLicensed() {
    const localKey = localStorage.getItem("theme_license_key");
    if (localKey) {
      const active = await checkLicenseFromServer(localKey);
      if (active) return true;
      localStorage.removeItem("theme_license_key");
    }

    // If no local key, ask Worker directly (shop-wide check)
    try {
      const res = await fetch(`${WORKER_URL}/validate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ shop: shopDomain, license_key: "default-check" }),
      });
      const data = await res.json();
      return data.success && data.active;
    } catch {
      return false;
    }
  }

  // --- Show activation screen if unlicensed
  function showActivationScreen() {
    document.body.innerHTML = `
<div style="
  position:fixed;top:0;left:0;width:100%;height:100%;
  display:flex;align-items:center;justify-content:center;
  background:white;z-index:9999;font-family:Inter,Arial,sans-serif;text-align:center;">
  
  <div style="
    max-width:420px;padding:30px;border-radius:10px;
    box-shadow:0 0 10px rgba(0,0,0,0.1)">
    
    <h2 style="margin-bottom:10px;">Theme Activation Required</h2>
    
    <p style="margin-bottom:20px;">
      Enter your activation key to unlock this theme.
    </p>
    
    <input id="licenseInput" type="text" placeholder="Enter Activation Key"
      style="width:100%;padding:10px;border:1px solid #ccc;
      border-radius:6px;margin-bottom:10px;font-size:15px;">
    
    <button id="activateBtn" style="
      background:#111;color:#fff;border:none;padding:10px 20px;
      border-radius:6px;cursor:pointer;width:100%;font-size:15px;">
      Activate Theme
    </button>

    <!-- Legal / informational notice -->
    <p style="
      margin-top:16px;
      font-size:13px;
      color:#555;
      line-height:1.5;">
      After delivery acceptance, you are welcome to use the work, as all agreed
      project requirements have been completed according to scope. Once the
      delivery is accepted, the theme activation key will be shared to enable
      full use of the work.
    </p>

    <p style="margin-top:18px;color:#777;font-size:14px;">
      Need help? Contact<br>
      <a href="mailto:engineerwaqasabbasi@gmail.com"
         style="color:#007bff;text-decoration:none;">
        engineerwaqasabbasi@gmail.com
      </a>
    </p>

  </div>
</div>

    `;

    document.getElementById("activateBtn").addEventListener("click", async () => {
      const key = document.getElementById("licenseInput").value.trim();
      if (!key) return alert("⚠️ Please enter your activation key.");

      try {
        const res = await fetch(`${WORKER_URL}/activate`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ shop: shopDomain, license_key: key }),
        });
        const data = await res.json();
        console.log("Activation response:", data);

        if (data.success && data.activated) {
          localStorage.setItem("theme_license_key", key);
          alert("✅ Theme activated successfully!");
          location.reload();
        } else {
          alert("❌ Invalid or expired key.");
        }
      } catch (err) {
        console.error("Activation error:", err);
        alert("⚠️ Could not reach activation server.");
      }
    });
  }

  // --- MAIN FLOW
  const licensed = await isShopLicensed();

  if (!licensed) {
    console.warn("Theme unlicensed for:", shopDomain);
    showActivationScreen();
  } else {
    console.log("✅ Theme active for", shopDomain);
  }
})();
